import React, {useState} from 'react';
import makeStyles from '@mui/styles/makeStyles';
import {
    Box,
    Button, CircularProgress,
    Grid,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Theme,
    Typography
} from "@mui/material";
import AppBar from "../../components/appBar";
import Strings from "../../assets/strings";
import {formatDate, formatPeso, translateText} from "../../helpers";
import defaultImg from "../../assets/img/no_image.jpg";
import {YoutubeSearchedFor} from "@mui/icons-material";
import {getHistorialCrediticio, getInfoByCedula} from "../../services";
import moment from "moment";
import {LoadingProgress} from "../../components";
import {SelectEnum} from "../../components/selects";
import {CedulaTextField} from "../../components/CustomTextField";

const useStyles = makeStyles((theme:Theme) => ({
    root:{
        maxWidth:900,
        margin:"0 auto",
        marginTop:20,
        padding:theme.spacing(2)
    },
    searchCont:{
        marginTop:"8%",
        marginBottom:"4%",
        display:"flex",
        margin:"0 auto",
        width: "100%",
        maxWidth: 250,
        padding: 2,
        border: "1px solid #bfbfbf",
        outline: "6px solid #e6e6e6",
        borderRadius: 5,
        "& .MuiInput-root":{
            border: "none",
            "&:before, &:after":{
                display: "none !important",
            }
        },
        "& input":{
            flexGrow: 1,
            padding: "6px !important",
            fontSize: 15,
            border: "none",
            outline: "none",
            lineHeight: "1px",

        }
    },
    title:{
        background: theme.palette.primary.main,
        padding: "3px 8px",
        "& p":{
            color: theme.palette.common.white,
        }
    }
}));
interface IHistorialCredito {
    nombres?: string,
    apellidos?: string,
    cedula?: string,
    sexo?: string,
    nacionalidad?: string,
    estadoCivil?: number,
    fechaNacimiento?: string,
    avatar?: string,
    detalle?: [
        {
            fecha?: string,
            fechaUltimoPago?: string,
            moneda?: string,
            montoCuota?: number,
            capitalInicial?: number,
            balancePendiente?: number,
            cuotasAtrasadas?: number,
            ciclosPago?: number,
            ciclosPagoString?: string,
            estado?: number,
            estadoString?: string,
            situacion?: number,
            situacionString?: string
        }
    ]
}
export default function HistorialCredito() {
    let [loading, setLoading] = useState(false);
    let [notFound, setNotFound] = useState(false);
    let [data, setData] = useState<IHistorialCredito>();
    let [cedula, setCedula] = useState("");
    const classes = useStyles();
    const buscarDatos = () => {
        setNotFound(false)
        setLoading(true)
        getHistorialCrediticio(cedula).then((response)=>{
            if(response.status === 200){
                setData(response.data)
            }else{
                setNotFound(true)
            }
        }).catch(e=>{
            setNotFound(true)
        }).finally(()=>setLoading(false))
    }
    return (
        <>
            <AppBar title={Strings.historialCredito}/>
            {/*{loading && <LoadingProgress vh/>}*/}

            {!data ?(
                <div  className={classes.root}>
                    <Box className={classes.searchCont}>
                        <CedulaTextField
                            disabled={loading} value={cedula}
                            required
                            // name={"documentoIdentidad"}
                            // label={"Número de ID Cónyuge"}

                            onChange={({target}:any)=> {
                                setCedula(target.value)
                            }}
                            fullWidth
                            onKeyUp={(e:any)=>{
                                let val = e.target.value.replace(/\D/g,'');
                                if(val.length === 11) {
                                    buscarDatos()
                                }
                            }}
                        />



                        {/*<input  disabled={loading} value={cedula} onChange={({target})=>setCedula(target.value)}/>*/}
                        <IconButton size={"small"} disabled={cedula.length !== 11 || !!loading} onClick={buscarDatos}>
                            {loading? <CircularProgress size={20} /> : <YoutubeSearchedFor/>}
                        </IconButton>
                    </Box>
                    {notFound ? (
                        <Typography align={"center"} m={1} color={"text.disabled"}>No se encontraron registros.</Typography>
                    ):(
                       <>
                           <Typography pb={1} align={"justify"}>
                               El <span style={{fontWeight:500}}>Historial De Crédito</span> es un informe detallado que muestra los balances y los estatus de los créditos de diversa naturaleza
                               aperturados por el consumidor en un lapso de tiempo no mayor a 4 años, de acuerdo a lo que establece la Ley No. 172-13.
                           </Typography>
                           <Typography align={"justify"}>
                               El reporte también ofrece informaciones sobre datos personales del prospecto, específicamente direcciones y números telefónicos asociados.
                           </Typography>
                       </>
                    )}




                </div>
            ):(
                <>
                    <Box  className={classes.root}>
                        <Box display={"flex"} justifyContent={"end"}>
                            <Button onClick={()=>setData(undefined)}>Consultar otro cliente</Button>
                        </Box>
                        <Box className={classes.title}>
                            <Typography>Datos Personales</Typography>
                        </Box>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={2}>
                                <Box display={"flex"} justifyContent={"center"}>
                                    <img style={{maxWidth: "100%", maxHeight:150, margin:3}} src={data.avatar ?? defaultImg} alt="avatar"/>
                                </Box>
                            </Grid>
                            <Grid item md={10}>
                                <Box p={1}>
                                    <Grid container spacing={1}>

                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("nombres"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{data.nombres}</Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("apellidos"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{data.apellidos}</Grid>

                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("cedula"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{data.cedula}</Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("estadoCivil"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}><SelectEnum group="estadosCivil" value={data.estadoCivil}/></Grid>



                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("fechaNacimiento"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{formatDate(data.fechaNacimiento)}</Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("edad"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{moment().diff(data.fechaNacimiento, 'years')} años</Grid>


                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("nacionalidad"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{data.nacionalidad}</Grid>
                                        <Grid item xs={6} sm={3}>
                                            <Typography fontWeight={500}>{translateText(("sexo"))}</Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={3}>{data.sexo}</Grid>


                                    </Grid>
                                </Box>
                            </Grid>
                        </Grid>


                        <Box className={classes.title}>
                            <Typography>Comportamiento Historico</Typography>
                        </Box>
                        <Box>
                            {data.detalle?.length?(
                                <TableContainer sx={{pb:1}}>
                                    <Table size={"small"}>
                                        <TableHead>
                                            <TableRow>
                                                {/*<TableCell>Prestador</TableCell>*/}
                                                <TableCell>Fecha Apertura</TableCell>
                                                <TableCell>Fecha Último Pago</TableCell>
                                                <TableCell>Moneda</TableCell>
                                                <TableCell>Monto Cuotas</TableCell>
                                                <TableCell>Monto Crédito</TableCell>
                                                <TableCell>Balance pendiente</TableCell>
                                                <TableCell>Cuotas Atrasadas</TableCell>
                                                <TableCell>Modalidad</TableCell>
                                                <TableCell>Estado</TableCell>
                                                <TableCell>Situación</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {data.detalle?.map((item, index)=>
                                                <TableRow key={index}>
                                                    <TableCell>{formatDate(item.fecha)}</TableCell>
                                                    <TableCell>{formatDate(item.fechaUltimoPago)}</TableCell>
                                                    <TableCell>{item.moneda}</TableCell>
                                                    <TableCell>{(item.montoCuota ?? 0).toLocaleString()}</TableCell>
                                                    <TableCell>{(item.capitalInicial ?? 0).toLocaleString()}</TableCell>
                                                    <TableCell>{(item.balancePendiente ?? 0).toLocaleString()}</TableCell>
                                                    <TableCell>{item.cuotasAtrasadas}</TableCell>
                                                    <TableCell>{item.ciclosPagoString}</TableCell>
                                                    <TableCell>{item.estadoString}</TableCell>
                                                    <TableCell>{item.situacionString}</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ):(
                                <Typography align={"center"} m={1} color={"text.disabled"}>No se encontraron registros.</Typography>
                            )}

                        </Box>

                        {/*<Box className={classes.title}>*/}
                        {/*    <Typography>Indagaciones Ultimos 6 Meses</Typography>*/}
                        {/*</Box>*/}
                        {/*<Box >*/}
                        {/*    <TableContainer >*/}
                        {/*        <Table size={"small"}>*/}
                        {/*            <TableHead>*/}
                        {/*                <TableRow>*/}
                        {/*                    <TableCell>Fecha / Hora	</TableCell>*/}
                        {/*                    <TableCell>Suscriptor</TableCell>*/}
                        {/*                    <TableCell>Tipo</TableCell>*/}
                        {/*                </TableRow>*/}
                        {/*            </TableHead>*/}
                        {/*            <TableBody>*/}
                        {/*                <TableRow>*/}
                        {/*                    <TableCell>13/03/2024 / 12:39PM</TableCell>*/}
                        {/*                    <TableCell>Segura inversiones</TableCell>*/}
                        {/*                    <TableCell>REVISION DE PORTAFOLIO</TableCell>*/}
                        {/*                </TableRow>*/}
                        {/*                <TableRow>*/}
                        {/*                    <TableCell>28/02/2024 / 09:48PM</TableCell>*/}
                        {/*                    <TableCell>SCOTIABANK</TableCell>*/}
                        {/*                    <TableCell>SOLICITUD DE CREDITO</TableCell>*/}
                        {/*                </TableRow>*/}
                        {/*            </TableBody>*/}
                        {/*        </Table>*/}
                        {/*    </TableContainer>*/}
                        {/*</Box>*/}


                    </Box>
                    <Box p={1} pb={2} className={classes.root}>
                            <Typography variant={"subtitle2"}>Final de reporte</Typography>
                            <Typography fontSize={12} letterSpacing={0} align={"justify"}>
                                Esta información se suministra como una herramienta de evaluación de riesgos, con el propósito de asistir en la toma de decisión en el otorgamiento de crédito y otras decisiones de negocios. Este reporte está fundamentado en información otorgada de buena fe por parte de otorgantes de crédito, y otras fuentes, en la forma y términos que se reciben de éstos.
                                {/*El uso abusivo de esta información, divulgación, acceso no autorizado, fuera de los fines establecidos por la Ley No.172-13, será sancionado en virtud de lo dispuesto en sus artículos 86-88.*/}
                                {/*Si la información desplegada en el presente reporte no responde a la situación real del titular, éste podrá presentar su reclamación ante el departamento de Servicio al Consumidor de Dsegura srl, de conformidad con el procedimiento establecido en los artículos 25 y siguiente de la Ley No. 172-13. Los Usuarios o Suscriptores, en virtud de dicha Ley, no podrán compartir, mostrar, o divulgar oralmente, o por escrito, ni mediante algún medio de transmisión electrónica, el contenido de los reportes a otras personas, que no sean empleados autorizados del Suscriptor, siempre y cuando lo haga en el ejercicio de sus funciones oficiales o contractuales y para los fines previstos por la Ley. Dsegura srl, sus empleados, funcionarios y accionistas, no serán responsables por la violación del Suscriptor, sus usuarios, o sus empleados, a las disposiciones contenidas en la Ley No. 172-13, de Protección de datos de carácter personal y que regula las Sociedades de Información Crediticia.*/}
                            </Typography>
                    </Box>
                </>
            )}
        </>
    )
}

